import React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { Utils } from '../../services';

/**
 * Switch Component
 * 
 * @example
 * <Switch checked={isEnabled} onCheckedChange={setIsEnabled} />
 */
function Switch({ className, ...props }) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={Utils.classNames(
                "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:focus-visible:border-primary data-[state=checked]:focus-visible:ring-blue-600/40 data-[state=unchecked]:focus-visible:border-slate-400 data-[state=unchecked]:focus-visible:ring-slate-400/50",
                className
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className={Utils.classNames(
                    "bg-background pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
                )}
            />
        </SwitchPrimitive.Root>
    );
}

export default Switch;

